<template>
  <div>
    <bj-crud-form-modal
      ref="crudModal"
      model="Lead"
      endpoint-edit="admin/leads"
      :fields="fields"
      not-crud
      @saved="refreshTable"
    />
    <bj-add-inquiry-modal
      ref="addInquiryModal"
      @added="refreshTable"
    />
    <div class="row full-row-exactly">
      <div class="col-12 flex-1">
        <bj-data-table
          ref="dataTable"
          model="admin/leads"
          many-name="Leads"
          single-name="Lead"
          title=""
          :with-cell-delete-button="false"
          :with-cell-edit-button="false"
          :with-total-count="false"
          :with-add-button="false"
          :columns="columns"
          :query-params="queryParams"
        >
          <template
            slot="cell-created_at"
            slot-scope="{row}"
          >
            <SdDatetime :value="row.created_at" />
          </template>
          <template
            slot="cell-full_name"
            slot-scope="{row}"
          >
            <SdLeadFullName
              :lead="row"
            />
            <q-icon
              v-if="row.notes"
              v-tippy
              class="ml-2"
              name="message"
              size="14px"
              :title="row.notes"
            />
          </template>
          <template
            slot="cell-inquiries"
            slot-scope="{row}"
          >
            <q-chip
              v-for="inquiry in row.inquiries"
              :key="inquiry.id"
            >
              <router-link
                :to="{ name: 'app.inquiries.timeline', params: { id: inquiry.id }}"
                target="_blank"
              >
                {{ inquiry.id }}
              </router-link>
            </q-chip>
          </template>
          <template
            slot="cell-actions"
            slot-scope="{row}"
          >
            <q-btn
              v-tippy
              rounded
              outline
              size="sm"
              color="primary"
              icon="edit"
              title="Edit"
              class="q-ml-sm"
              @click.native="$refs.crudModal.open('edit', ...row)"
            />
            <q-btn
              v-tippy
              rounded
              outline
              size="sm"
              color="green"
              icon="add"
              title="Add Inquiry"
              class="q-ml-sm"
              @click.native="openInquiryModal(row)"
            />
          </template>
        </bj-data-table>
      </div>
    </div>
  </div>
</template>

<script>
import SdLeadFullName from '@/components/common/SdLeadFullName';
import BjAddInquiryModal from '../../../components/add-inquiry-modal';

export default {
  components: { BjAddInquiryModal, SdLeadFullName },

  data() {
    return {
      columns: [
        {
          name: 'id',
          field: 'id',
          label: 'ID',
          sortable: true,
        },
        {
          name: 'created_at',
          field: 'created_at',
          label: 'Created At',
          sortable: true,
        },
        {
          name: 'full_name',
          field: 'full_name',
          label: 'Full Name',
          sortable: false,
        },
        {
          name: 'email',
          field: 'email',
          label: 'Email',
          sortable: true,
        },
        {
          name: 'formatted_phone_number',
          field: 'formatted_phone_number',
          label: 'Phone Number',
          sortable: false,
        },
        {
          name: 'inquiries',
          field: 'inquiries',
          label: 'Inquiries',
          sortable: false,
        },
      ],
      fields: [
        {
          name: 'first_name',
          label: 'First Name',
          type: 'text',
          rules: ['required'],
          class: 'col-md-6 col-xs-12',
        },
        {
          name: 'last_name',
          label: 'Last Name',
          type: 'text',
          class: 'col-md-6 col-xs-12',
        },
        {
          name: 'phone_number',
          label: 'Phone Number',
          type: 'text',
          rules: [{
            name: 'requiredUnless',
            field: 'email',
          }, 'phone'],
          error: 'You must fill a valid phone number',
          class: 'col-md-6 col-xs-12',
        },
        {
          name: 'email',
          label: 'Email',
          type: 'email',
          rules: [{
            name: 'requiredUnless',
            field: 'phone_number',
          }, 'email'],
          error: 'You must fill a valid email address',
          class: 'col-md-6 col-xs-12',
        },
        {
          name: 'is_blocked',
          label: 'Block lead',
          type: 'checkbox',
          class: 'col-md-6 col-xs-12',
        },
      ],
      queryParams: {
        id: this.$route.params.id || null,
      },
    };
  },
  created() {
    [this.queryParams] = this.applySortingAndFiltering(this.queryParams, null);
  },
  mounted() {
    this.$root.$on('fetched', (queryParams) => {
      if (this.queryParams !== null && (queryParams.page != this.queryParams.page
          || queryParams.limit != this.queryParams.limit)) {
        this.queryParams.page = queryParams.page;
        this.queryParams.limit = queryParams.limit;
      }
      this.addParamsToLocation(queryParams);
    });
  },
  methods: {
    refreshTable() {
      this.$refs.dataTable.refresh();
    },
    openInquiryModal(lead) {
      const leadDetails = {
        first_name: lead.first_name,
        last_name: lead.last_name,
        phone_number: lead.phone_number,
        email: lead.email,
      };
      this.$refs.addInquiryModal.show(leadDetails);
    },
  },
};
</script>
